import React, { useState, useEffect, useMemo } from 'react';
import { useContent } from '../../../contexts/ContentContext';
import { AboutFullBodySlideList, AboutFullPageSlidesEnabled } from '../../../content/keys';

export default function AboutPartnersSection({ section }) {
  const { c } = useContent();

  // Body carousel slides — key matches what the dashboard writes
  const bodySlides = useMemo(() => {
    const raw = c(AboutFullBodySlideList, '');
    return raw
      ? raw.split(',').map(s => s.trim()).filter(s => s && /^https?:\/\//i.test(s))
      : [];
  }, [c]);

  // Show if toggle is on AND valid slides exist, or just if valid slides exist
  const enabledFlag = c(AboutFullPageSlidesEnabled, '');
  const showBodySlides = bodySlides.length > 0 && (enabledFlag === 'True' || enabledFlag === '');

  if (!showBodySlides) return null;

  return (
    <div className="mb-8 sm:mb-16 md:mb-20">
      <BodyCarousel slides={bodySlides} />
    </div>
  );
}

/** Simple body image carousel matching the legacy About page pattern. */
function BodyCarousel({ slides }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return;
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  if (!slides.length) return null;

  return (
    <div className="max-w-4xl mx-auto">
      <div
        className="w-full h-48 xs:h-64 sm:h-80 rounded-2xl bg-cover bg-center transition-all duration-500 shadow-lg"
        style={{ backgroundImage: `url(${slides[index]})` }}
      />
      {slides.length > 1 && (
        <div className="flex justify-center gap-2 mt-4">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              className={`w-3 h-3 rounded-full transition-all ${i === index ? 'bg-blue-500 scale-125' : 'bg-gray-400 dark:bg-gray-600 hover:bg-gray-500'}`}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
